module.exports = __webpack_public_path__ + "static/media/logo.6d8e5e33.svg";